import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './Login.css';
import logo from '../../Images/logo_pmpc.png';
import axiosInstance from '../../Config/axiosInstance'; 

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      await axiosInstance.post('/token/', { email, password });
  
      const permissionsResponse = await axiosInstance.get('/permissions/');
  
      localStorage.setItem('permissions', JSON.stringify(permissionsResponse.data));
  
      navigate('/home');
      window.location.reload(); 
    } catch (error) {
      console.error('Error during login:', error);
      setError('Invalid credentials, please try again!');
    }
  };
  
  

  return (
    <div className="login-page">
      <div className="login-box">
        <img src={logo} alt="Logo" className="logo-login" />
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="button-login" type="submit">Login</button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default Login;
